import { cn } from '@tebuto/lib/utils'

export default function MediumText({
    children,
    className,
    ...rest
}: { children?: React.ReactNode } & React.HTMLAttributes<HTMLParagraphElement>) {
    return (
        <p {...rest} className={cn('md:text-sm text-xs text-foreground-secondary', className)}>
            {children}
        </p>
    )
}
